function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8025 2.71749C30.8517 -0.905826 36.1485 -0.905831 38.1976 2.71748L66.1474 52.1386C68.1413 55.6643 65.5505 60 61.4498 60H5.55032C1.44971 60 -1.1411 55.6643 0.85279 52.1387L28.8025 2.71749Z",
  fill: "#F4BB22"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0946 40.3695H30.859L29.8773 20.3291H37.0295L36.0946 40.3695ZM33.4768 50.4788C31.4199 50.4788 29.7371 48.831 29.7371 46.916C29.7371 44.9565 31.4199 43.3088 33.4768 43.3088C35.5336 43.3088 37.2632 44.9565 37.2632 46.916C37.2632 48.831 35.5336 50.4788 33.4768 50.4788Z",
  fill: "#2B2B2B"
});

function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.eac9969a.svg";
export { ForwardRef as ReactComponent };